import Vue from "vue";
import Vuex from "vuex";
import { authenticate, register, get_user_details } from "../api";
import { EventBus, isValidJwt } from "../utils";
import notification from "./notification";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    jwt: {},
    role: "",
    drawer: false,
    schedule: null,
    schedules: [],
    userData: {}, //TODO: Check later,
    userDetails: {
      profile_image_url: "",
      last_name: "",
      middle_name: "",
      first_name: "",
      username: "",
      title: "",
      role: "",
      mobile_number: "",
      email: "",
    },
  },
  mutations: {
    setUserData(state, payload) {
      state.userData = payload.userData;
    },
    setLoginInfo(state, payload) {
      localStorage.token = payload.jwt.access_token;
      localStorage.role = payload.jwt.role;
      state.jwt = payload.jwt;
    },
    setSurveys(state, payload) {
      state.schedules = payload.schedules;
    },
    setSurvey(state, payload) {
      const nQuestions = payload.survey.questions.length;
      for (let i = 0; i < nQuestions; i++) {
        payload.survey.questions[i].choice = null;
      }
      state.currentSurvey = payload.survey;
    },
    setLogout(state) {
      state.jwt = {};
      localStorage.removeItem("token");
    },
    setUserDetails(state, payload) {
      state.userDetails = payload.userDetails;
    },
  },
  actions: {
    login(context, userData) {
      return authenticate(userData)
        .then((response) =>
          context.commit("setLoginInfo", { jwt: response.data })
        ).catch((error) => {
          EventBus.$emit("failedAuthentication", error);
        });
    },
    logout(context) {
      context.commit("setLogout");
    },
    register(context, userData) {
      context.commit("setUserData", { userData });
      return register(userData)
        .then(context.dispatch("login", userData))
        .catch((error) => {
          EventBus.$emit("failedRegistering", error);
        });
    },
    userDetails(context, jwt) {
      return get_user_details(jwt)
        .then((res) => {
          return context.commit("setUserDetails", { userDetails: res.data });
        })
        .catch((error) => {
          EventBus.$emit("retrieving user details", error);
        });
    },
  },
  getters: {
    isAuthenticated(state) {
      // Handling for Page Refresh: Retrieve token from local storage
      const token = state.jwt.access_token || localStorage.getItem("token");
      return isValidJwt(token);
    },
    getUserRole(state) {
      return state.jwt.role || localStorage.getItem("role");
    },
    getJwt(state) {
      return state.jwt.access_token || localStorage.getItem("token");
    },
    getUserDetails(state) {
      return state.userDetails;
    },
    getState(state) {
      return state;
    },
    isServiceProvider(state) {
      /* TODO: Fix this duplicate code from isAuthenticated */
      const token = state.jwt.access_token || localStorage.getItem("token");
      if (!isValidJwt(token)) {
        return false;
      }

      const role = state.jwt.role || localStorage.getItem("role");
      return (
        role === "Psychologist" ||
        role === "Counselor" ||
        role === "Psychiatrist"
      );
    },
    isSecretary(state) {
      /* TODO: Fix this duplicate code from isServiceProvider */
      const token = state.jwt.access_token || localStorage.getItem("token");
      if (!isValidJwt(token)) {
        return false;
      }

      const role = state.jwt.role || localStorage.getItem("role");
      return role === "Secretary";
    },
  },
  modules: { notification },
});
